if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.comboForm = this.querySelector('form.combo-form')
      this.form.querySelectorAll('[name=id]').forEach((elem) => elem.disabled = false);
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      this.buynowButton = this.querySelector('button[name="buynow"]');
      this.buynowButton.addEventListener('click', this.onSubmitHandler.bind(this));
      
      this.buynowButton.mode = 'buynow';
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.querySelector(".combo-form").style.setProperty("display", "none", "important");
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      let isBuyNow = false;
      let buynowBtn;
      if (typeof evt.target.mode != 'undefined' && evt.target.mode == "buynow") {
        isBuyNow = true;
        buynowBtn = evt.target;
      }
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      
      
      if (!isBuyNow) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      } else {
        buynowBtn.classList.add('loading');
        buynowBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }
      

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart && !isBuyNow) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;


        const data = {
          items: [
            {
              quantity: 1,
              id: formData.get("id")
            }
          ]
        };
        if (this.comboForm != null) {
          const comboFormData = new FormData(this.comboForm);
          const paddingId = formData.get("padding_id")
          // push twin product with twin's and padding's properties and current url 
          data.items.push({quantity: 1, id: comboFormData.get("id"), properties:{_comboItem: formData.get("id"), _comboProduct: formData.get("id"), _padding: paddingId, _handle: window.location.pathname}})
          // push padding
          if (paddingId.length > 5) data.items.push({quantity: 1, id: paddingId, properties:{_comboItem: formData.get("id"), _comboProduct: comboFormData.get("id")}})
          // push properties to original item and current url 
          data.items[0].properties = {_mainItem: formData.get("id"), _comboProduct: comboFormData.get("id"), _padding: paddingId, _handle: window.location.pathname}
          

        }
        if (!isBuyNow) {
          var actionURL = `/cart/add.js?sections=${this.cart.getSectionsToRender().map((section) => section.id)}`;
        }else {
          var actionURL = `/cart/add.js`;
        }
        
        const xhr = new XMLHttpRequest();
        xhr.open('POST', actionURL, true);
        xhr.responseType = 'json';
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhr.onreadystatechange = () => {
          // Call a function when the state changes.
          const response = xhr.response;
          
          if (response && response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (isBuyNow) {
            window.location = "/checkout";
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
      xhr.send(JSON.stringify(data));
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}